import * as React from 'react';
import { Icon, Text } from '@fluentui/react';
import { TitleBarLabel } from '@uifabric/portal-ux/lib/TitleBar';
import { classNames } from './TermsOfUseCard.styles';

export interface ITermsOfUseCardCollapsedProps {
  readonly agreementDisplayName: string;
  readonly acceptanceDateText: string;
  readonly deviceDisplayNameText: string;
}

export const TermsOfUseCardCollapsed: React.FC<ITermsOfUseCardCollapsedProps> = ({
  agreementDisplayName,
  acceptanceDateText,
  deviceDisplayNameText,
}) => {
  return (
    <TitleBarLabel className={classNames.panelClass}>
      <Icon iconName="TextDocument" className={classNames.iconClass} />
      <div className={classNames.panelHeadingClass}>
        <div className={classNames.contentTitleClass}>{agreementDisplayName}</div>
        {acceptanceDateText && <Text>{acceptanceDateText}</Text>}
        {deviceDisplayNameText && (
          <>
            <br />
            <Text>{deviceDisplayNameText}</Text>
          </>
        )}
      </div>
    </TitleBarLabel>
  );
};
